import React from 'react';
import { Workflow } from '../../../ports/WorkflowService';
import { FlexBox, FlexDirection, FlexWrap } from '../../../utils/css-classes';
import CopyComponent from '../../utils/CopyComponent';

// tslint:disable-next-line:function-name
export function BulkShipmentsWorkflowInput({ workflow }: { workflow: Workflow }) {
  return <>
    <h6>Void Reason</h6>
    {(workflow.input as any).reason}
    <h6>Shipments</h6>
    <div
      className={`${FlexBox.FLEX} ${FlexDirection.ROW} ${FlexWrap.WRAP}`}
      style={{ maxHeight: '450px', overflowY: 'auto' }}
    >
      {(workflow.input as any).shipments.map(
        (shipment: { id: string; displayName?: string; }, i: number) => <div key={i} style={{ width: '40%' }}>
          {shipment.displayName ?? shipment.id} <CopyComponent value={shipment.id} title="Copy the shipment id" />
        </div>,
      )}
    </div>
  </>;
}
